import { render, staticRenderFns } from "./FlagBasedSurvey.vue?vue&type=template&id=6c1bf5cc&scoped=true&"
import script from "./FlagBasedSurvey.vue?vue&type=script&lang=ts&"
export * from "./FlagBasedSurvey.vue?vue&type=script&lang=ts&"
import style0 from "./FlagBasedSurvey.vue?vue&type=style&index=0&id=6c1bf5cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1bf5cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6c1bf5cc', component.options)
    } else {
      api.reload('6c1bf5cc', component.options)
    }
    module.hot.accept("./FlagBasedSurvey.vue?vue&type=template&id=6c1bf5cc&scoped=true&", function () {
      api.rerender('6c1bf5cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/cancellation/components/FlagBasedSurvey.vue"
export default component.exports